module.exports = __webpack_public_path__ + "static/media/no-search.29484480.png";